// External libraries
import React, { ReactElement, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// UI Components
import { Box, Button, Typography } from '@material-ui/core';

// Style
import '../style/home-style.scss';

const HeaderComponent: React.FC = (): ReactElement => {
	const [width, setWidth] = useState(1000);

	useEffect(() => {
		onResize();
		window.addEventListener('resize', onResize);

		return () => {
			window.removeEventListener('resize', onResize);
		};
	}, []);

	function onResize() {
		setWidth(window.innerWidth);
	}

	// Carousel settings
	const sliderSettings = {
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false,
		fade: true,
		cssEase: 'linear'
	};

	// Image data with target paths
	const carouselImages = [
		{
			src: 'images/zgrada2-1.jpg',
			path: '/projekti'  // Added target path
		},
		{
			src: 'images/zgrada1-1.jpg',
			path: '/projekti'  // Added target path
		}
	];

	const isMobilePhone = width < 800;
	const titleSize = isMobilePhone ? 'h4' : 'h3';
	const headingAlignRight = isMobilePhone ? 'center' : 'right';
	const textAlignRight = isMobilePhone ? 'justify' : 'right';
	const headingAlignLeft = isMobilePhone ? 'center' : 'left';
	const textAlignLeft = isMobilePhone ? 'justify' : 'left';

	return (
		<>
			{/* Modified Image Carousel */}
			<div className='main-image-carousel-wrapper'>
				<Slider {...sliderSettings}>
					{carouselImages.map((item, index) => {
						return (
							<div key={index}>
								<Link to={item.path} style={{ display: 'block', height: '100%' }}>
									<div
										className='main-image'
										style={{
											backgroundImage: `url(${item.src})`,
											cursor: 'pointer'
										}}
									/>
								</Link>
							</div>
						);
					})}
				</Slider>
			</div>

			{/* Rest of your original code remains unchanged below */}
			<div className='text-container'>
				<Typography variant={titleSize} gutterBottom={true} color='secondary' align={headingAlignRight}>
					Kope Bau – za vaše bolje sutra.
				</Typography>
				<Box m={4}/>
				<Typography variant='h6' color='textPrimary' align={textAlignRight}>
					Kope Bau prati dinamiku moderne svakodnevice.
					<br/>
					Ovaj objekat je koncipiran tako da odgovara svim generacijama i raznovrsnim životnim stilovima.
					<br/>
					Savremeni dizajn i visoka funkcionalnost, kao i prirodna osvetljenost stanova čine Kope Bau ponudu jedinstvenom u Pančevu.
				</Typography>
			</div>

			<div className='to-left-prim-sec'></div>

			<div className='location'>
				<img src='images/pancevo.jpg' alt='Slika dnevne sobe' className='location-image slide-left'/>
				<div className='loc-text'>
					<Box m={4}/>
					<Typography variant='h3' gutterBottom={true} color='primary' align={headingAlignRight}>
						Lokacija
					</Typography>
					<Box m={4}/>
					<Typography variant='h6' color='textPrimary' align={textAlignRight}>
						Kope Bau objekat nalazi se u neposrednoj okolini Beograda,
						<br/>
						ali daleko od gradske gužve, saobraćajnog kolapsa i bučne okoline.
						<Box m={4}/>
						Dovoljno daleko da Vam pruži potpuni mir,
						<br/>
						a dovoljno blizu da kratkom šetnjom stignete do centra.
					</Typography>
					<Box m={4}/>
					<Button
						variant='outlined'
						color='primary'
						className='location-btn'
						size='large'
						component={Link}
						to='/lokacija'
					>
						Saznaj više
					</Button>
				</div>
			</div>

			<div className='to-right-sec-white'></div>

			<div className='content'>
				<div>
					<Typography variant='h3' gutterBottom={true} color='secondary' align={headingAlignLeft}>
						Stanovi
					</Typography>
					<Box m={4}/>
					<Typography variant='h6' color='primary' align={textAlignLeft}>
						Kope Bau objekat nudi 8 stanova, podeljenih na 4 sprata.
						<br/>
						Takođe, poseduje dva garažna parking mesta u prizemlju zgrade.
						<Box m={4}/>
						Građen je po najvišim arhitektonskim standardima uz korišćenje vrhunskih materijala,
						<br/>
						što će Vam pružiti potpuni ugođaj savremenog života.
					</Typography>
					<Box m={'15%'}/>
					<div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
						<Button
							variant='outlined'
							color='secondary'
							className='content-btn'
							size='large'
							component={Link}
							to='/stanovi'
						>
							Stanovi
						</Button>
						<Button
							variant='outlined'
							color='secondary'
							className='content-btn'
							size='large'
							component={Link}
							to='/sadrzaj'
						>
							Naša gradnja
						</Button>
					</div>
				</div>
				<img src='images/home-bedroom.jpeg' alt='Slika dnevne sobe' className='home-bedroom-image'/>
			</div>
			{/* ... */}
		</>

	);
};

export default HeaderComponent;